import React, { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../Controls/TextBoxControl"
import GridControl from "../../../Controls/GridControl"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { json, useNavigate } from "react-router-dom";

import {
	GetLocal,
	SetLocal,
	FetchService,
	GetParamsUrl
} from "../../../Base/BaseControl";
import TextBoxNumericControl from '../../../Controls/TextBoxNumericControl';
import ButtonControl from '../../../Controls/ButtonControl';



export default function Index(props) {
	const inputOwnerNameRef = useRef(null);
	const inputFileNumberRef = useRef(null);

	const navigate = useNavigate();
	const [getServiceResult, setServiceResult] = useState(false);
	const [getPdf, setPdf] = useState('');
	const [showModal, setShowModal] = useState(false);

	const [getFileNumberState, setFileNumberState] = useState(true);
	const [getOwnerNameState, setOwnerNameState] = useState(true);


	const [getFileNumberValueState, setFileNumberValueState] = useState(null);
	const [getOwnerNameValueState, setOwnerNameValueState] = useState(null);


	const [searchType, setSearchType] = useState('GetReviewReportByAllFiles');



	useEffect(() => {
		GetEngineerFileList()
	}, []);



	const GetEngineerFileList = () => {

		var inputValue = {
			session: GetLocal('EngineerSession') || null,
			documentNumber: getFileNumberValueState ? String(getFileNumberValueState) : null,
			ownerName: getOwnerNameValueState || null
		};
		FetchService("Engineer/Request/GetEngineerFileList", inputValue, GetEngineerFileListSuccess);
	}

	const GetEngineerFileListSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult.EngineerFileList);
	}

	let customRenderCell = {
		Reports: (row) => (
			<i class="fa fa-table" onClick={() => ShowReportsList(row)}></i>
		),
		InsertReports: (row) => (
			<i class="fa fa-plus-square" onClick={() => CreateEngineerReport(row)}></i>
		),
		LicenseReport: (row) => (
			<i class="fa fa-file-text-o" onClick={() => ShowLastConstruction(row)}></i>
		)
	};

	const CreateEngineerReport = (value) => {
		SetLocal('FileNumber', value.FileNumber)
		navigate("/Engineer/CreateEngineerReport?page=ثبت گزارش", { state: value });
	}

	const ShowReportsList = (value) => {
		SetLocal('FileNumber', value.FileNumber)
		navigate("/Engineer/ShowReportsList?page=گزارش ها");
	}

	const ShowLastConstruction = (row) => {
		var inputValue = {
			session: GetLocal('EngineerSession'),
			fileNumber: row.FileNumber
		};
		FetchService("Engineer/Request/ShowLastConstruction", inputValue, ShowLastConstructionSuccess);
	}

	const ShowLastConstructionSuccess = (ServiceResult) => {
		setPdf("data:application/pdf;base64," + ServiceResult);
		setShowModal(true)
	}

	//-------------
	const clearInputs = () => {
		if (inputFileNumberRef?.current?.value) {
			inputFileNumberRef.current.value = null

		}
		if (inputOwnerNameRef?.current?.value) {
			inputOwnerNameRef.current.value = null

		}
	}

	const SetTypeLevel = (val) => {
		setFileNumberState(true);
		setOwnerNameState(true);
		setOwnerNameValueState(null)
		setFileNumberValueState(null)
		clearInputs()
		setSearchType(val);
		if (val === 'GetReviewReportByFileNumber') {
			setFileNumberState(false); // false means enabled
			setOwnerNameState(true);  // true means disabled
			setOwnerNameValueState(null)
		} else if (val === "GetFilesByOwnerName") {
			setFileNumberState(true);  // true means disabled
			setFileNumberValueState(null)
			setOwnerNameState(false); // false means enabled
		} else {
			setOwnerNameValueState(null)
			setFileNumberValueState(null)
			setFileNumberState(true);
			setOwnerNameState(true)
		}

	}
	const fileNumberInputOnChange = (value) => {
		setFileNumberValueState(value)
	}
	const ownerNameInputOnChange = (value) => {
		setOwnerNameValueState(value)

	}



	const BtnGetServiceResult = () => {
		setServiceResult([]);
		GetEngineerFileList()
	}


	return (
		<div>
			<table dir="rtl" className="col col-sm-12 col-md-6 gap-2">
				<tbody>
					<tr>
						<td style={{ "width": "10%" }}><input onClick={() => SetTypeLevel('GetReviewReportByFileNumber')}
							checked={searchType == 'GetReviewReportByFileNumber'} type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "30%" }}>{"شماره پروانه / گواهی"}</td>
						<td style={{ "width": "100%" }}>
							<TextBoxNumericControl
								required={true}
								className="mt-3"
								maxlength={11}
								inputRef={inputFileNumberRef}
								disabled={getFileNumberState}
								placeholder="شماره پروانه / گواهی"
								onChange={fileNumberInputOnChange}
								value={getFileNumberValueState}
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px" }}><input onClick={() => SetTypeLevel('GetFilesByOwnerName')}
							checked={searchType == 'GetFilesByOwnerName'}
							type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>نام مالک</td>
						<td style={{ "width": "50px" }} colspan="4">
							<TextBoxControl
								required={true}
								maxlength={1000}
								inputRef={inputOwnerNameRef}
								disabled={getOwnerNameState}
								placeholder="نام مالک"
								onChange={ownerNameInputOnChange}
								value={getOwnerNameValueState}
							/>
						</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td style={{ "width": "17px", minHeight: "63px", lineHeight: "100%" }}><input
							onClick={() => SetTypeLevel('GetReviewReportByAllFiles')}
							checked={searchType == 'GetReviewReportByAllFiles'}
							type="radio" name="FilesRadio" className="align-bottom" /></td>
						<td style={{ "width": "10px" }}>کلیه پرونده ها</td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
						<td style={{ "width": "50px" }}></td>
					</tr>
					<tr>
						<td colspan="7" className="text-end">
							<ButtonControl
								variant="primary float-left w-25 mx-2"
								title="جستجو"
								onClick={BtnGetServiceResult}
								icon="fa fa-search"
							/>
						</td>
					</tr>
				</tbody>
			</table>

			<hr />
			<GridControl
				data={getServiceResult}
				customHeaders={{ "FileNumber": "شماره پرونده", "RenovationCode": "کد نوسازی", "DocumentNumber": "شماره پروانه / گواهی", "IssueDate": "تاریخ صدور", "EngineerType": "عنوان مهندس", "OwnerName": "نام مالک", "Address": "نشانی ملک", "Reports": "گزارش ها", "InsertReports": "درج گزارش", "LicenseReport": "مشاهده آخرین پروانه" }}
				customRenderCell={customRenderCell}
			/>

			<Modal dialogClassName="modalUi" show={showModal} onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title></Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<iframe src={getPdf} width="100%" style={{ height: "500px" }}></iframe>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="danger" onClick={() => setShowModal(false)}>
						بستن
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
